import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import i18next from "i18next";

// Helper function to get translations using global i18next from config namespace
const tViews = (key, defaultValue = "") => {
  try {
    // Use config namespace for route-related translations
    return i18next.isInitialized
      ? i18next.t(key, { ns: "views", defaultValue })
      : defaultValue;
  } catch (error) {
    console.warn(`Translation key "${key}" not found in config namespace`);
    return defaultValue;
  }
};

const [HbrViewSwitcher, HbrRadioButton] = reactWrapper([
  "hbr-view-switcher",
  "hbr-radio-button",
]);
const qoeHealth = [
  {
    key: "all",
    get value() {
      return tViews("app360AllQoeLabel");
    },
  },
  {
    key: "good",
    get value() {
      return tViews("app360GoodLabel");
    },
  },
  {
    key: "fair",
    get value() {
      return tViews("app360FairLabel");
    },
  },
  {
    key: "poor",
    get value() {
      return tViews("app360PoorLabel");
    },
  },
  {
    key: "gray",
    get value() {
      return tViews("app360UnknownLabel");
    },
  },
];

const QoEFilter = ({ value, onChange, loader = false }) => (
  <HbrViewSwitcher value={value} onHbr-change={onChange}>
    {qoeHealth.map(({ key, value }) => (
      <HbrRadioButton key={key} value={key} disabled={loader}>
        {value}
      </HbrRadioButton>
    ))}
  </HbrViewSwitcher>
);

QoEFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loader: PropTypes.bool,
};

export default QoEFilter;
